<template>
  <div class="bill full-height display-col">
    <full-con :canReturn='canReturn'>
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="full">
        <div class="bill_box full-height flex1 overflowAuto">
          <p class="bill_title">{{ title }}</p>
          <div class="title_border"></div>
          <div class="bill_item">
            <div class="bill_top">
              <span>支付状态：<i>{{ status }}</i></span>
              <span>订单编号：<i>{{ addFormInfo.orderNumber }}</i></span>
              <span v-if="isAdd === false">付款单编号：<i>{{ addFormInfo.paymentNumber }}</i></span>
            </div>
            <div slot="search">
              <el-row class="search-row">
                <el-col :span="6" class="display-row">
                  <div class="query-title">付款人：</div>
                  <div class="flex1">
                    <el-input disabled placeholder="请输入内容" clearable v-model="addFormInfo.userName" size="small">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="6" class="display-row">
                  <div class="query-title">总应收：</div>
                  <div class="flex1">
                    <el-input disabled placeholder="请刷新" clearable v-model="showFormInfo.totalAmount" size="small">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="6" class="display-row">
                  <div class="query-title">总优惠：</div>
                  <div class="flex1">
                    <el-input disabled placeholder="请输入内容" clearable v-model="addFormInfo.discountAmount" size="small">
                    </el-input>
                  </div>
                </el-col>
                <el-col :span="6" class="display-row">
                  <div class="query-title">总收费(元)：</div>
                  <div class="flex1">
                    <el-input disabled placeholder="请刷新" clearable v-model="showFormInfo.receivedAmount" size="small">
                    </el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row class="search-row">
                <el-col :span="18" class="display-row">&nbsp;</el-col>
                <el-col :span="6" class="display-row">
                  <div class="query-title">总收费 + 币种：</div>
                  <div class="flex1 action">
                    {{ formatSettlementAmount(addFormInfo) }}
                  </div>
                </el-col>
              </el-row>
            </div>
            <el-form ref="form" :model="addFormInfo" :rules="addFormInfo.rules">
              <el-table :data="addFormInfo.paymentItemList" border
                :header-cell-style="{ background: '#F1F2F6', color: '#3A4255' }" style="width: 100%" height="550">
                <el-table-column width="" v-if="isAdd == '1'">
                  <template slot="header">
                    <el-tooltip placement="top" popper-class="toolTipClass">
                      <div slot="content">新增一行账单</div>
                      <i class="el-icon-circle-plus" @click="addBill"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <i class="el-icon-remove" @click="delBill(scope.$index)"></i>
                  </template>
                </el-table-column>>
                <el-table-column prop="configPayProjectId" label="收费项目" width="">
                  <template slot-scope="scope">
                    <el-form-item label=" " :prop="'paymentItemList.' + scope.$index + '.configPayProjectId'"
                      :rules="addFormInfo.rules.configPayProjectId">
                      <el-select v-model="scope.row.configPayProjectId" placeholder="请选择" clearable size="small"
                        @change='configPayProjectChange(scope.row.configPayProjectId)' :disabled='isAdd == false'
                        width='100'>
                        <el-option v-for="item in configPayProjectList" :key="item.value" :label="item.name"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格（元）" width="">
                  <template slot-scope="scope">
                    <el-form-item label=" " :prop="'paymentItemList.' + scope.$index + '.price'"
                      :rules="addFormInfo.rules.price">
                      <el-input-number v-model="scope.row.price" size="small" clearable :precision="2"
                        style="width:150px" @change="payChange()" :disabled='isAdd == false'></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="count" label="数量" width=" ">
                  <template slot-scope="scope">
                    <el-form-item label=" " :prop="'paymentItemList.' + scope.$index + '.count'"
                      :rules="addFormInfo.rules.count">
                      <el-input-number v-model="scope.row.count" size="small" clearable :precision="0" :min="0"
                        style="width:150px" @change="payChange()" :disabled='isAdd == false'></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="receivableAmount" label="应收金额（元）" width="">
                  <template slot-scope="scope">
                    <el-form-item label=" " :prop="'paymentItemList.' + scope.$index + '.receivableAmount'">
                      <el-input v-model="scope.row.receivableAmount" size="small" clearable disabled></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="discountAmount" label="优惠金额（元）" width="">
                  <template slot-scope="scope">
                    <el-form-item label=" " :prop="'paymentItemList.' + scope.$index + '.discountAmount'"
                      :rules="addFormInfo.rules.discountAmount">
                      <el-input-number v-model="scope.row.discountAmount" size="small" clearable :precision="2" :min="0"
                        :max="Number(scope.row.receivableAmount)" style="width:150px" @change="payChange()"
                        :disabled='isAdd == false'></el-input-number>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="receivedAmount" label="实收金额（元）" width="">
                  <template slot-scope="scope">
                    <el-form-item label=" " :prop="'paymentItemList.' + scope.$index + '.receivedAmount'">
                      <el-input v-model="scope.row.receivedAmount" size="small" clearable disabled></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column prop="currencyAmount" label="实收金额 + 币种" width="">
                  <template slot-scope="scope">
                    {{ formatSettlementAmount(scope.row) }}
                  </template>
                </el-table-column>
              </el-table>
              <el-form-item label="收款备注" :prop="addFormInfo.remark" label-width="100px" style="margin-top:20px">
                <el-input v-model="addFormInfo.remark" size="small" clearable style="width:650px"></el-input>
              </el-form-item>
              <el-form-item class="btn" v-if="isAdd == true">
                <el-button class="form-btn btn-gray" @click="initBill" style="margin-right:100px">初始化</el-button>
                <el-button class="form-btn btn-green" v-if="!isManage" @click="saveItem"
                  style="margin-right:100px">保存</el-button>
                <el-button class="form-btn btn-blue" v-if="isManage" @click="saveAndSendItem">保存并发送</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </full-con>
    <!-- <el-dialog
          :visible.sync="ShowImg"
          @close="ShowImg=false"
          width="35%"
      >
        <div>
          <img :src="showImgUrl" alt="" width="100%" height="auto">
        </div>
      </el-dialog> -->
  </div>
</template>
<script>
import editBreadcrumb from '../../views/layout/components/editBreadCrumb'

export default {
  data() {
    return {
      canReturn: '1',
      pageTitle: '账单',
      isAdd: null,
      title: '',
      status: '',// 支付状态
      configPayProjectList: [],// 收费项目列表
      initParameter: [],// 初始化 参数
      showFormInfo: {},// 用于展示数据带千位符
      addFormInfo: {
        paymentNumber: '',// 账单编号
        orderNumber: '',// 订单编号
        paymentStatus: '',// 支付状态:0未支付1已支付2无费用
        userName: '',// 客户名（付款人）
        receivedAmount: '',// 总收费
        receivedAmountJp: '',// 总收费日
        discountAmount: '',// 优惠金额(总优惠）
        totalAmount: '',// 总应付款
        remark: '',// 备注
        paymentItemList: [
          {
            configPayProjectId: '',// 收费项目id
            price: '',// 价格
            count: null,// 数量
            discountAmount: '',// 优惠金额
            receivableAmount: '',// 应收金额
            receivedAmount: '',// 实际金额
            goodsNumber: 0,// 货品数
            userRate: '',// 用户折扣
            packageRate: '',// 包裹折扣
            delFlag: '',// 是否删除标识：0否1是
            payType: '',// 支付方式：0->未支付；1虚拟账户;2->支付宝；3->微信
            id: ''// 账单详情id
          }
        ],
        rules: {
          configPayProjectId: [
            { required: true, message: '请选择收费项目', trigger: 'blur' }
          ],
          price: [
            { required: true, message: '请输入价格', trigger: 'blur' }
          ],
          count: [
            { required: true, message: '请输入数量', trigger: 'blur' }
          ],
          discountAmount: [
            { required: true, message: '请输入优惠金额', trigger: 'blur' }
          ]
        }
      },
    }
  },
  components: { editBreadcrumb },
  created() {
    // if (this.$route.query.isAdd == 0) {
    //     this.isAdd = 0
    //     this.title = '账单详情'
    //     this.listen(this.$route.query.id)
    // } else if (this.$route.query.isAdd == 1) {
    //     this.isAdd = 1
    //     this.title = '发送账单'
    //     this.cancelItem(this.$route.query.id)
    // }
    // this.getAllConfigPayProjectList()
  },
  mounted() {
    this.getAllConfigPayProjectList()
      .then(() => {
        if (this.$route.query.isAdd == 0) {
          this.isAdd = 0;
          this.title = '账单详情';
          this.listen(this.$route.query.id);
        } else if (this.$route.query.isAdd == 1) {
          this.isAdd = 1;
          this.title = '发送账单';
          this.cancelItem(this.$route.query.id);
        }
      })
      .catch((error) => {
        console.error('获取收费项目失败:', error);
      });
  },
  computed: {
    isManage() {
      return window.sessionStorage.getItem('role') == '超级管理员' || window.sessionStorage.getItem('role') == '超超级管理员'
    }
  },
  watch: {

  },
  methods: {
    // 千位符
    addThousandsSeparator(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    // 价格改变
    payChange() {
      const data = this.addFormInfo.paymentItemList
      this.addFormInfo.receivedAmount = 0
      this.addFormInfo.discountAmount = 0
      this.addFormInfo.totalAmount = 0
      for (let i in data) {
        data[i].receivableAmount = (data[i].price * data[i].count).toFixed(2)
        data[i].receivedAmount = ((data[i].price * data[i].count).toFixed(2) - data[i].discountAmount).toFixed(2)
        console.log(`第 ${i} 项：price = ${data[i].price}, count = ${data[i].count}, discountAmount = ${data[i].discountAmount}, receivedAmount = ${data[i].receivedAmount}`)
        this.addFormInfo.totalAmount = (Number(this.addFormInfo.totalAmount) + Number(data[i].receivableAmount)).toFixed(2)
        this.addFormInfo.discountAmount = (Number(this.addFormInfo.discountAmount) + Number(data[i].discountAmount)).toFixed(2)
        this.addFormInfo.receivedAmount = (Number(this.addFormInfo.receivedAmount) + Number(data[i].receivedAmount)).toFixed(2)
      }
      this.showFormInfo.totalAmount = this.addThousandsSeparator(this.addFormInfo.totalAmount)
      this.showFormInfo.receivedAmount = this.addThousandsSeparator(this.addFormInfo.receivedAmount)
    },

    // 获取所有的收费项目列表
    getAllConfigPayProjectList() {
      return new Promise((resolve, reject) => {
        let that = this;
        const configPayProjectPromise = that.$http.get('configPayProject/getAllConfigPayProject').then((res) => {
          if (res.data.code === 200) {
            that.configPayProjectList = res.data.data;
          }
        });

        Promise.all([configPayProjectPromise]).then(() => {
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 获取数据
    listen(id) {
      let that = this
      that.$http.post("cmsContainer/getBill/", { "containerBatchNo": this.$route.query.containerBatchNo }).then((res) => {
        if (res.data.code == 200) {
          Object.assign(that.addFormInfo, res.data.data)
          that.addFormInfo.paymentNumber = res.data.data.paymentNumber
          that.addFormInfo.orderNumber = res.data.data.orderNumber
          that.addFormInfo.paymentStatus = res.data.data.paymentStatus
          that.addFormInfo.userName = res.data.data.userName
          that.addFormInfo.receivedAmount = res.data.data.receivedAmount ? res.data.data.receivedAmount.toFixed(2) : 0
          that.addFormInfo.discountAmount = res.data.data.discountAmount ? res.data.data.discountAmount.toFixed(2) : 0
          that.addFormInfo.totalAmount = res.data.data.totalAmount ? res.data.data.totalAmount.toFixed(2) : 0
          that.addFormInfo.remark = res.data.data.remark
          that.addFormInfo.paymentItemList = res.data.data.list
          if (that.addFormInfo.paymentStatus == 0) {
            that.status = '未支付'
          } else if (that.addFormInfo.paymentStatus == 1) {
            that.status = '已支付'
          } else {
            that.status = '无费用'
          }
        }
      })
    },
    configPayProjectChange(val) {
      console.log(val)
    },
    // 添加账单
    addBill() {
      this.addFormInfo.paymentItemList.push({
        paymentNumber: '',
        orderNumber: '',
        paymentStatus: '',
        userName: '',
        receivedAmount: '',
        discountAmount: '',
        totalAmount: '',
        configPayProjectId: '',
        price: 0,
        count: 1,
        goodsNumber: 0,
        userRate: '',
        packageRate: '',
        delFlag: '',
        payType: '',
        id: '',
        remark: ''
      })
      this.payChange()
    },
    // 删除账单
    delBill(i) {
      if (this.addFormInfo.paymentItemList != null && this.addFormInfo.paymentItemList.length == 1) {
        this.$message.warning('至少保留一条收费项')
        return
      }
      this.addFormInfo.paymentItemList.splice(i, 1)
      this.payChange()
    },
    // 点击初始化
    initBill() {
      this.$router.go(0)
    },
    // 点击发送账单（检验） 获取账单
    cancelItem() {
      console.log(222222222);

      let that = this
      let containerBatchNo = this.$route.query.containerBatchNo
      that.$http.post('cmsContainer/clickSendBill', { "containerBatchNo": containerBatchNo }).then((res) => {
        if (res.data.code == 200) {
          that.$message({
            message: '初始化成功',
            type: 'success'
          })
          that.addFormInfo.containerBatchNo = res.data.data.containerBatchNo
          Object.assign(that.addFormInfo, res.data.data)
          that.addFormInfo.paymentNumber = res.data.data.paymentNumber
          that.addFormInfo.orderNumber = res.data.data.orderNumber
          that.addFormInfo.paymentStatus = res.data.data.paymentStatus
          that.addFormInfo.sendFlag = res.data.data.sendFlag
          that.addFormInfo.userId = res.data.data.userId
          that.addFormInfo.orderType = res.data.data.orderType
          that.addFormInfo.goodsNumber = res.data.data.goodsNumber
          that.addFormInfo.payType = res.data.data.payType
          that.addFormInfo.userName = res.data.data.userName
          that.addFormInfo.receivedAmount = res.data.data.receivedAmount ? res.data.data.receivedAmount.toFixed(2) : 0
          that.addFormInfo.discountAmount = res.data.data.discountAmount ? res.data.data.discountAmount.toFixed(2) : 0
          that.addFormInfo.totalAmount = res.data.data.totalAmount ? res.data.data.totalAmount.toFixed(2) : 0
          that.addFormInfo.remark = res.data.data.remark
          that.addFormInfo.paymentItemList = res.data.data.list
          if (that.addFormInfo.paymentStatus == 0) {
            that.status = '未支付'
          } else if (that.addFormInfo.paymentStatus == 1) {
            that.status = '已支付'
          } else {
            that.status = '无费用'
          }
        } else {
          that.$message({
            message: res.data.message,
            type: 'error'
          })
        }
      })
    },
    // 返回页面
    returnPage() {
      this.$router.push({
        path: 'container'
      })
    },
    // 保存
    saveItem() {
      let that = this
      let condition = false
      if (this.addFormInfo.paymentItemList.length == 0) {
        that.$message({
          message: '订单不存在',
          type: 'error'
        })
      } else {
        this.addFormInfo.paymentItemList.forEach(o => {
          if (o.count == 0 || o.price == 0) {
            condition = true
          }
        })
        if (condition) {
          that.$message({
            message: '单价和数量不能为0！',
            type: 'error'
          })
        } else {
          let data = that.addFormInfo
          this.$set(data, 'listJson', JSON.stringify(this.addFormInfo.paymentItemList))
          this.$refs['form'].validate((valid) => {
            if (valid) {
              that.$http.post('cmsContainer/saveBill', data).then((res) => {
                if (res.data.code == 200) {
                  that.$message({
                    message: res.data.message,
                    type: 'success'
                  })
                  that.$router.go(-1)
                } else {
                  that.$message({
                    message: res.data.message,
                    type: 'error'
                  })
                }
              })
            }
          })
        }
      }
    },
    // 保存并发送
    saveAndSendItem() {
      let that = this
      let condition = false
      if (this.addFormInfo.paymentItemList.length == 0) {
        that.$message({
          message: '订单不存在',
          type: 'error'
        })
      } else {
        this.addFormInfo.paymentItemList.forEach(o => {
          if (o.count == 0 || o.price == 0) {
            condition = true
          }
        })
        if (condition) {
          that.$message({
            message: '单价和数量不能为0！',
            type: 'error'
          })
        } else {
          this.$confirm('确认保存并发送该账单？', '提示', {
            confirmButtonText: "确定",
            confirmButtonClass: "form-btn btn-blue",
            cancelButtonText: "取消",
            cancelButtonClass: "form-btn btn-gray",
            type: 'warning'
          }).then(() => {
            let data = that.addFormInfo
            this.$set(data, 'listJson', JSON.stringify(this.addFormInfo.paymentItemList))
            this.$refs['form'].validate((valid) => {
              if (valid) {
                that.$http.post('cmsContainer/sendBill', data).then((res) => {
                  if (res.data.code == 200) {
                    that.$message({
                      message: res.data.message,
                      type: 'success'
                    })
                    that.$router.go(-1)
                  } else {
                    that.$message({
                      message: res.data.message,
                      type: 'error'
                    })
                  }
                })
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        }
      }
    }
  }
}

</script>
<style scoped lang="less">
.bill_box {
  background: #fff;
}

.bill_title {
  width: 100%;
  height: 80px;
  color: #606266;
  /* border-bottom:1px solid #606266 ; */
  text-align: center;
  line-height: 80px;
  font-size: 24px;
}

.title_border:after {
  content: '';
  display: block;
  height: 1px;
  background: #dfe5e4;
}

.bill_item {
  padding: 10px 10px;
}

.bill_top {
  width: 100%;
  height: 20px;
  margin: 10px;
  padding-right: 15px;
}

.bill_top span {
  display: block;
  float: right;
  margin-left: 20px;
}

.bill_top i {
  text-decoration: underline;
}

.query-title {
  text-align: right;
}

.el-form /deep/ .cell {
  text-align: center;
  /* height: 40px;
    line-height: 40px; */
  vertical-align: middle;
}

.el-form /deep/.el-input {
  margin-top: 10px
}

.el-form /deep/ .el-form-item__content {
  display: flex;

}

.el-form /deep/.el-form-item__label {
  display: inline !important;
  float: left !important;
  margin-top: 4px !important;
}

.el-form /deep/.el-input--small {
  display: inline !important;
  float: left !important;
}

.el-form /deep/.el-input__inner {
  display: inline;
}

.el-form /deep/.el-input-number__decrease {
  margin-top: 10px
}

.el-form /deep/.el-input-number__increase {
  margin-top: 10px
}

.el-form /deep/ .el-input-number {
  margin-top: 5px;
}

.el-form /deep/ .el-icon-circle-plus {
  font-size: 20px;
  color: #67C23A;
}

.el-form /deep/ .el-icon-remove {
  font-size: 20px;
  color: #F56C6C;
}

.el-form /deep/ .el-table__row {
  height: 40px;
  vertical-align: middle;
}

.btn {
  display: flex;
  justify-content: center;
}

::v-deep.action .el-input.is-disabled .el-input__inner {
  color: #ff691f;
}
</style>
